import { GAME_WIDTH, GAME_HEIGHT, SCENE } from '../../config.js';
import { makeVisitScene } from './VisitSceneBase.js';
import { ROOM_PERSPECTIVE } from '../roomPerspective.mjs';
import { SECOND_FLOOR_POLYLINE } from '../SecondFloorScene.js';
import { homeArrival } from '../homeLayout.mjs';

// Host's second floor — same as the owner SecondFloorScene: same floor, and the elevator
// (bottom edge) takes you back down to Home.
export const VisitSecondFloorScene = makeVisitScene({
  key: SCENE.VISIT_SECOND_FLOOR,
  roomScene: 'SecondFloorScene',
  areaKey: 'second_floor',
  bgKey: () => 'bg_second_floor',
  spawn: { x: GAME_WIDTH / 2, y: GAME_HEIGHT - 240 },
  perspective: ROOM_PERSPECTIVE.second_floor,
  floorPolyline: SECOND_FLOOR_POLYLINE,
  exits: [
    { side: 'bottom', toScene: SCENE.VISIT_HOME, label: '{arrow_down} Zjedź windą na dół', data: homeArrival('drugie_pietro') },
  ],
});
